import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getFormActions = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-actions`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form-actions:', error.response?.data || error);
    throw error;
  }
};

export const getFormActionById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/form-actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching form-action:', error.response?.data || error);
    throw error;
  }
};

export const createFormAction = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/form-actions`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating form-action:', error.response?.data || error);
    throw error;
  }
};

export const updateFormAction = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/form-actions/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating form-action:', error.response?.data || error);
    throw error;
  }
};

export const deleteFormAction = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/form-actions/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting form-action:', error.response?.data || error);
    throw error;
  }
};
